<template>
    <div class="file-preview ms-2" role="button">
      <!-- Изображения -->
      <img
        v-if="isImage && showImage"
        :src="fileUrl"
        class="file-preview__image"
        @load="handleImageLoad"
        @error="handleImageError"
        :alt="altText"
      />
      
      <!-- Иконки для других файлов -->
      <div v-else class="file-preview__icon">
        
        <!-- PDF -->
        <svg v-if="fileExtension === 'pdf'" class="file-preview__icon-svg">
          <use href="@/assets/images/icons/file-type-pdf.svg#icon"></use>
        </svg>
        
        <!-- Word -->
        <svg v-else-if="['doc', 'docx'].includes(fileExtension)" class="file-preview__icon-svg">
          <use href="@/assets/images/icons/file-type-doc.svg#icon"></use>
        </svg>
        
        <!-- Excel -->
        <svg v-else-if="['xls', 'xlsx'].includes(fileExtension)" class="file-preview__icon-svg">
          <use href="@/assets/images/icons/file-type-xls.svg#icon"></use>
        </svg>
        
        <!-- Архивы -->
        <svg v-else-if="['zip', 'rar', '7z'].includes(fileExtension)" class="file-preview__icon-svg">
          <use href="@/assets/images/icons/file-type-zip.svg#icon"></use>
        </svg>
        
        <!-- Видео -->
        <svg v-else-if="['mp4', 'mov', 'avi'].includes(fileExtension)" class="file-preview__icon-svg">
          <use href="@/assets/images/icons/file-type-video.svg#icon"></use>
        </svg>
        
        <!-- Аудио -->
        <svg v-else-if="['mp3', 'wav', 'ogg'].includes(fileExtension)" class="file-preview__icon-svg">
          <use href="@/assets/images/icons/file-type-default.svg#icon"></use>
        </svg>
        
        <!-- По умолчанию -->
        <svg v-else class="file-preview__icon-svg">
          <use href="@/assets/images/icons/file-type-default.svg#icon"></use>
        </svg>
      </div>
    </div>
</template>
  
<script>
  export default {
    name: 'FilePreview',
    props: {
      fileUrl: {
        type: String,
        required: true
      },
      altText: {
        type: String,
        default: 'File preview'
      },
      customImageExtensions: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        showImage: true,
        defaultImageExtensions: [
          'jpg', 'jpeg', 'png', 'gif', 
          'webp', 'svg', 'bmp', 'tiff'
        ]
      }
    },
    computed: {
      fileExtension() {
        if (!this.fileUrl) return '';
        const cleanUrl = this.fileUrl.split(/[?#]/)[0];
        const matches = cleanUrl.match(/\.([a-z0-9]+)(?:[\?#]|$)/i);
        return matches ? matches[1].toLowerCase() : '';
      },
      isImage() {
        const allImageExtensions = [
          ...this.defaultImageExtensions,
          ...this.customImageExtensions
        ];
        return allImageExtensions.includes(this.fileExtension);
      }
    },
    methods: {
      handleImageLoad() {
        this.showImage = true;
      },
      handleImageError() {
        this.showImage = false;
      }
    }
  }
</script>
  
<style scoped>
  .file-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px solid #C3CDD8;
    border-radius: 5px;
    overflow: hidden;
    background: #f8f9fa;
    transition: all 0.2s ease;
    width: 32px;
    height: 32px;
  }
  
  .file-preview:hover {
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .file-preview__image {
    max-width: 100%;
    max-height: 200px;
    display: block;
    object-fit: contain;
  }
  
  .file-preview__icon {
    width: 24px;
    height: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0;
    box-sizing: border-box;
  }
  
  .file-preview__icon-svg {
    width: 24px;
    height: 24px;
    color: #5f6368; /* Цвет по умолчанию для иконок */
  }
  
  /* Специфичные цвета для типов файлов */
  .file-preview__icon-svg use[href*="pdf"] {
    color: #FF5252;
  }
  .file-preview__icon-svg use[href*="word"] {
    color: #2B579A;
  }
  .file-preview__icon-svg use[href*="excel"] {
    color: #217346;
  }
  .file-preview__icon-svg use[href*="archive"] {
    color: #795
  }
</style>